<template>
  <div class="fomo-stats-page">
    <div class="row page-heading">
      <h2 class="title">
        Filter click stats
      </h2>
      <div class="row">
        <router-link :to="{ name: 'GeneralStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('general')">
            General stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'UserStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('user')">
            User stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'PortalStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('portal')">
            Portal stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'ConsumptionStats' }" class="page-link">
          <q-btn
            flat
            class="btn-navigation"
            :class="isUnderlined('consumption')"
          >
            Consumption stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'FilterClicksStats' }" class="page-link">
          <q-btn
            flat
            class="btn-navigation"
            :class="isUnderlined('filter-clicks')"
          >
            Filter clicks stats
          </q-btn>
        </router-link>
        <!--         <router-link :to="{ name: 'FomoStats' }" class="page-link">
          <q-btn flat class="btn-navigation" :class="isUnderlined('fomo')">
            Fomo stats
          </q-btn>
        </router-link> -->
      </div>
    </div>

    <div class="row">
      <q-btn
        @click="exportFilterClicksStats()"
        no-caps
        label="Export data"
        type="submit"
        class="btn-vind-dark"
        style="margin-left: 64px"
      />
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import statsService from "../../services/stats.service";
export default {
  name: "FomoStats",

  setup() {
    const route = useRoute();
    const exportFilterClicksStats = async () => {
      await statsService.exportFilterClicksStats().then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        var a = document.createElement("a");
        a.setAttribute("style", "display:none;");
        document.body.appendChild(a);
        a.download = "FilterClicksStats.xlsx";
        a.href = fileURL;
        a.target = "_blank";
        a.click();
        document.body.removeChild(a);
      });
    };

    return {
      route,
      exportFilterClicksStats
    };
  },

  methods: {
    isUnderlined(buttonRoute) {
      if (this.route.fullPath.includes(buttonRoute))
        return "btn-nav-underlined";
      return "";
    }
  }
};
</script>
